import React from 'react'
import { NuqsAdapter } from 'nuqs/adapters/react-router/v6'
import { VndlyIssuesMain } from './components/VndlyIssuesMain'
import { VndlyIssuesProvider } from './context/VndlyIssuesProvider'

export const VndlyIssues = () => {
  return (
    <NuqsAdapter>
      <VndlyIssuesProvider>
        <VndlyIssuesMain />
      </VndlyIssuesProvider>
    </NuqsAdapter>
  )
}
